// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"SectionHeading_sectionHeading__1jEq9","white":"SectionHeading_white__3FwPD","tall":"SectionHeading_tall__2Z80S"};